import { userApi } from '~/api'
import { useQuery } from '@tanstack/react-query'

export const useUpcomingCoursesQuery = () =>
  useQuery({
    queryKey: ['upcoming-courses'],
    queryFn: async () => {
      const { data } = await userApi.getUpcomingCourses()
      return data.data
    }
  })

export const usePastCoursesQuery = () =>
  useQuery({
    queryKey: ['past-courses'],
    queryFn: async () => {
      const { data } = await userApi.getPastCourses()
      return data.data
    }
  })
